import { render, staticRenderFns } from "./SelectWidgetTypePopup.vue?vue&type=template&id=0cbca9f3&scoped=true&"
import script from "./SelectWidgetTypePopup.vue?vue&type=script&lang=js&"
export * from "./SelectWidgetTypePopup.vue?vue&type=script&lang=js&"
import style0 from "./SelectWidgetTypePopup.vue?vue&type=style&index=0&id=0cbca9f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbca9f3",
  null
  
)

export default component.exports